import { CdkScrollable } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';

import { TranslateModule } from '@ngx-translate/core';

export const MODULES = [
  CommonModule,
  MatDialogModule,
  MatButtonModule,
  TranslateModule,
];
export const DIRECTIVES = [CdkScrollable];

@Component({
  selector: 'app-dialog-remove-user',
  templateUrl: 'dialog-remove-user.component.html',
  imports: [...MODULES, ...DIRECTIVES],
})
export class DialogRemoveUserComponent {
  private injectedData = inject(MAT_DIALOG_DATA);
  data = signal(this.injectedData);
}
